import type { ReactNode } from 'react';
import { CompareWithSavingsAccountCheckbox } from '../inputs/compare-with-savings-account-checkbox';
import { InitialInvestmentInput, MonthlyContributionInput, SavingPeriodYearsInput } from '../inputs/numeric-input';
import { InitialInvestmentSlider, MonthlyContributionSlider, SavingPeriodYearsSlider } from '../inputs/slider-input';
import './controls.scss';

interface ControlsProps {
    children: ReactNode;
}

export const Controls = ({ children }: ControlsProps) => <div className="controls">{children}</div>;

interface ControlGroupProps {
    children: ReactNode;
}

const ControlGroup = ({ children }: ControlGroupProps) => <div className="controls__control-group">{children}</div>;

const InitialInvestment = () => (
    <ControlGroup>
        <InitialInvestmentInput />
        <InitialInvestmentSlider />
    </ControlGroup>
);

const MonthlyContribution = () => (
    <ControlGroup>
        <MonthlyContributionInput />
        <MonthlyContributionSlider />
    </ControlGroup>
);

const SavingPeriodYears = () => (
    <ControlGroup>
        <SavingPeriodYearsInput />
        <SavingPeriodYearsSlider />
    </ControlGroup>
);

Controls.InitialInvestment = InitialInvestment;
Controls.MonthlyContribution = MonthlyContribution;
Controls.SavingPeriodYears = SavingPeriodYears;
Controls.CompareWithSavingsAccount = CompareWithSavingsAccountCheckbox;
